var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.courseStatus === -1)?void 0:(_vm.courseStatus === 2)?void 0:(_vm.courseStatus === 1)?void 0:(_vm.courseStatus === 0)?[_c('div',{staticClass:"learning_join",on:{"click":function($event){$event.stopPropagation();return _vm.enterRoom(_vm.data)}}},[_vm._v("进入课堂")])]:(_vm.courseStatus === 3)?void 0:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }